import { render, staticRenderFns } from "./AssistantContainer.vue?vue&type=template&id=03ab80ad"
import script from "./AssistantContainer.vue?vue&type=script&lang=ts"
export * from "./AssistantContainer.vue?vue&type=script&lang=ts"
import style0 from "./AssistantContainer.vue?vue&type=style&index=0&id=03ab80ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports